import { IGetDraftOrderIdResponse } from 'app/models/responses/order';
import { serverAxios } from 'app/utils/axios';
import { AxiosResponse } from 'axios';
import { ICreateOrderData } from './models/order';

class OrderHttp {
  private static route = '/';

  public async create(data: ICreateOrderData): Promise<void> {
    return serverAxios
      .post(OrderHttp.route, {
        act: 'insert',
        col: 'jobs',
        data,
      })
      .then(() => {
        return;
      });
  }

  public async createDraft(data: ICreateOrderData): Promise<string> {
    return serverAxios
      .post(OrderHttp.route, {
        act: 'jobdraft',
        data,
      })
      .then((response: AxiosResponse<IGetDraftOrderIdResponse>) => {
        return response.data.id;
      });
  }

  public async confirmDraft(id: string, draftPass: string, lang: string): Promise<void> {
    return serverAxios
      .post(OrderHttp.route, {
        act: 'jobdraftconfirm',
        id,
        draftPass,
        lang,
      })
      .then(() => {
        return;
      });
  }
}

export default OrderHttp;
